import { HttpPostFunction } from "@lookiero/sty-psp-http";
import {
  CheckoutFeedbackDefinitionByCheckoutIdView,
  ViewCheckoutFeedbackDefinitionByCheckoutIdResult,
} from "../../../projection/checkoutFeedback/viewCheckoutFeedbackDefinitionByCheckoutId";

interface HttpCheckoutFeedbackDefinitionByCheckoutIdView extends CheckoutFeedbackDefinitionByCheckoutIdView {}

interface HttpCheckoutFeedbackDefinitionByCheckoutIdViewFunctionArgs {
  readonly httpPost: HttpPostFunction;
}

interface HttpCheckoutFeedbackDefinitionByCheckoutIdViewFunction {
  (args: HttpCheckoutFeedbackDefinitionByCheckoutIdViewFunctionArgs): HttpCheckoutFeedbackDefinitionByCheckoutIdView;
}

const httpCheckoutFeedbackDefinitionByCheckoutIdView: HttpCheckoutFeedbackDefinitionByCheckoutIdViewFunction =
  ({ httpPost }) =>
  async ({ checkoutId, signal }) =>
    await httpPost<ViewCheckoutFeedbackDefinitionByCheckoutIdResult>({
      endpoint: "/view-checkout-feedback-definition-by-checkout-id",
      body: { checkoutId },
      signal,
      result: {
        error: null,
        success: (response) => response,
      },
    });

export { httpCheckoutFeedbackDefinitionByCheckoutIdView };
